import httpClient from "../../clients/httpClient";
import { IQuery } from "../../interfaces/meta.interface";
import { IOffAppOrderAvailability, IPunchcard, IPunchcardPreviewPayload, IPunchcardQuery, IPunchcardRedemption, IPunchcardRedemptionResponse, IPunchcardResponse } from "../../interfaces/punchcard.interface";
import { IFormSummary } from "../../interfaces/form-summary.interface";

export const getPunchcards = (query: IQuery) => {
    return httpClient.get<IPunchcardResponse>("/api/v1/punchcards", {
        params: {
            page: query?.page,
            per_page: query?.perPage,
            search: query?.search,
        },
    });
};

export const getPunchcard = (id: number) => {
    return httpClient.get(`/api/v1/punchcards/${id}`, {
        params: {
            include: "stores,tags,eligible_tags",
        }
    });
};

export const createPunchcard = (payload: FormData, version: number = 2) => {
    return httpClient.post<IPunchcard>(`/api/v${version}/punchcards`, payload, {
        params: {
            include: "stores,tags",
        }
    });
};

export const editPunchcard = (id: number, payload: FormData, version: number = 2) => {
    return httpClient.post<IPunchcard>(`/api/v${version}/punchcards/${id}`, payload, {
        params: {
            include: "stores,tags",
        }
    });
};

export const createPunchcardWizard = (payload: FormData) => {
    return httpClient.post<IPunchcard>(`/api/v2/punchcards/wizard`, payload, {
        params: {
            include: "stores,tags,eligible_tags",
        }
    });
};

export const editPunchcardWizard = (id: number, payload: FormData) => {
    return httpClient.post<IPunchcard>(`/api/v2/punchcards/wizard/${id}`, payload, {
        params: {
            include: "stores,tags,eligible_tags",
        }
    });
};

export const previewPunchcardWizard = (payload: IPunchcardPreviewPayload) =>
    httpClient.post<IFormSummary>("/api/v2/punchcards/wizard/preview", payload);

// Tenant-scoped capability read: says whether the off-app earning setting may
// be offered on this tenant's punch cards at all.
export const getOffAppOrderAvailability = () => {
    return httpClient.get<IOffAppOrderAvailability>(
        "/api/v1/punchcards/off-app-order-availability"
    );
};

export const deletePunchcard = (id: number) => {
    return httpClient.delete(`/api/v1/punchcards/${id}`);
};

export const getAllPunchcardsRequest = () => {
    return httpClient.get("/api/v1/punchcards");
};

export const sortPunchcardsRequest = (ids: number[]) => {
    return httpClient.patch("/api/v1/punchcards/sort", { punchcard_ids: ids });
};


export const getCustomerPunchcards = (organizationId: number, userId: number, query: IPunchcardQuery) => {
    return httpClient.get<IPunchcardResponse>(`/api/v1/organizations/${organizationId}/customer/${userId}/punchcards`, {
        params: {
            page: query?.page,
            per_page: query?.perPage,
            status: query?.status,
            include: query?.include,
        },
    });
}

export const approvePunchcardRedemption = (organizationId: number, userId: number, punchcardId: number, punchcardRedemptionId: number) => {
    return httpClient.post<IPunchcardRedemption>(`/api/v1/organizations/${organizationId}/customer/${userId}/punchcards/${punchcardId}/punchcard-redemptions/${punchcardRedemptionId}/approve`);
}

export const addManualPunch = (organizationId: number, userId: number, punchcardId: number) => {
    return httpClient.post(`/api/v1/organizations/${organizationId}/customer/${userId}/punchcards/${punchcardId}/punch`);
}
